export default class AbstractClassInstantiationException extends Error {
    constructor(message = null) {
        super(message || 'Absztrakt osztály, nem lehet példányosítani!');
    }
}
